import { Injectable, inject } from "@angular/core";
import { IframeMessagesService } from "../iframe-messages-service/iframe-messages.service";
import { IJobsJobModel } from "../interfaces/jobs-job-model.interface";
import { IJobsBulkJobModel } from "../interfaces/jobs-job-bulk-modal.interface";

@Injectable({
    providedIn: "root",
})
export class JobsAndBillingJobsService {
    private readonly iframeMessagesService = inject(IframeMessagesService);

    async updateJob(jobId: string, data: IJobsJobModel | null) {
        if (data) {
            const result = await this.iframeMessagesService.postMessageResp(
                "updateJobsAndBillingJob",
                { jobId, data: { data } },
                "jobsAndBillingJobUpdated",
            );
            if (result.status === "success") {
                return result.response;
            }
            throw new Error("Failed to update job");
        }
    }

    async updateBulkJobs(data: IJobsBulkJobModel) {
        if (data) {
            const result = await this.iframeMessagesService.postMessageResp(
                "updateBulkJobsAndBillingJobs",
                { data },
                "jobsAndBillingBulkJobsUpdated",
            );
            if (result.status === "success") {
                return result.response;
            }
            throw new Error("Failed to update job");
        }
    }
}
